import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { MpayrollConcept } from '../entities/mpayroll-concept';
import { EmployeePayroll } from '../model/employee-payroll';
import { catchError, tap } from 'rxjs/operators';
import { ResponsePageable } from 'app/shared/_utils/services/responsePageable';
import { Observable } from 'rxjs';

@Injectable()
export class MpayrollConceptService extends BaseCrudService<MpayrollConcept> {

  public uri = '/api/mpayrollConcept/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance MpayrollConceptService');
  }

  buildSentence(entity?: MpayrollConcept, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.amount ?
          `amount${QueryOperator.Contain}${entity.amount}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.formula ?
          `formula${QueryOperator.Contain}${entity.formula}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.mpayrollKeyword ?
          `mpayrollKeyword${QueryOperator.Equal}${entity.mpayrollKeyword}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.orderNumber ?
          `orderNumber${QueryOperator.Contain}${entity.orderNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCalculatePayroll ?
          `isCalculatePayroll${QueryOperator.Contain}${entity.isCalculatePayroll}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isShowReport ?
          `isShowReport${QueryOperator.Contain}${entity.isShowReport}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isUnitEdition ?
          `isUnitEdition${QueryOperator.Equal}${entity.isUnitEdition}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isDeductionImpact ?
          `isDeductionImpact${QueryOperator.Equal}${entity.isDeductionImpact}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isSpp ?
          `isSpp${QueryOperator.Equal}${entity.isSpp}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isSnp ?
          `isSnp${QueryOperator.Equal}${entity.isSnp}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isApe ?
          `isApe${QueryOperator.Equal}${entity.isApe}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isQuinta ?
          `isQuinta${QueryOperator.Equal}${entity.isQuinta}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isLawdeduction ?
          `isLawdeduction${QueryOperator.Equal}${entity.isLawdeduction}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isQuintaDiscount ?
          `isQuintaDiscount${QueryOperator.Equal}${entity.isQuintaDiscount}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCts ?
          `isCts${QueryOperator.Equal}${entity.isCts}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.month && entity.month.id) {
        query = query.concat(
          `month.id${QueryOperator.Equal}${entity.month.id}${QueryOperator.Split}`
        );
      }
      if (entity.calculationType) {
        query = query.concat(entity.payrollConcept.id ?
          `calculationType.id${QueryOperator.Equal}${entity.calculationType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.calculationType.code ?
          `calculationType.code${QueryOperator.Contain}${entity.calculationType.code}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
      }
      if (entity.unitType && entity.unitType.id) {
        query = query.concat(
          `unitType.id${QueryOperator.Equal}${entity.unitType.id}${QueryOperator.Split}`
        );
      }
      if (entity.employeeType && entity.employeeType.id) {
        query = query.concat(
          `employeeType.id${QueryOperator.Equal}${entity.employeeType.id}${QueryOperator.Split}`
        );
      }
      if (entity.expenseNature && entity.expenseNature.id) {
        query = query.concat(
          `expenseNature.id${QueryOperator.Equal}${entity.expenseNature.id}${QueryOperator.Split}`
        );
      }
      if (entity.payrollConcept) {
        query = query.concat(entity.payrollConcept.id ?
          `payrollConcept.id${QueryOperator.Equal}${entity.payrollConcept.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.payrollConcept.code ?
          `payrollConcept.code${QueryOperator.Contain}${entity.payrollConcept.code}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.payrollConcept.name ?
          `payrollConcept.name${QueryOperator.Contain}${entity.payrollConcept.name}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.payrollConcept && entity.payrollConcept.fiscalYear ?
          `payrollConcept.fiscalYear.id${QueryOperator.Equal}${entity.payrollConcept.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.payrollConcept && entity.payrollConcept.executingUnit ?
          `payrollConcept.executingUnit.id${QueryOperator.Equal}${entity.payrollConcept.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
      }
      if (entity.payrollType && entity.payrollType.id) {
        query = query.concat(
          `payrollType.id${QueryOperator.Equal}${entity.payrollType.id}${QueryOperator.Split}`
        );
      }
      if (entity.sign) {
        if (entity.sign == '+') {
          let encodedName = encodeURI("payrollConcept.sign_eq_+;");
          // console.log(entity.sign);
          query = query.concat(encodedName);
        }
        else {
          // console.log(entity.sign);
          query = query.concat(
            `payrollConcept.sign${QueryOperator.Equal}${entity.sign}${QueryOperator.Split}`
          );
        }

      }
      // console.log(query);
      // console.log(encodeURI(query));
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
      this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'orderNumber');
    }
    //  console.log(this.httpParams);
    return this.httpParams;
  }



  copyMPayrollConcept(params: EmployeePayroll) {
    const url = `${this.rutaServidor}${this.uri}copyMPayrollConcept`;
    this.spinnerService.showAll();
    return this.httpClient.post<EmployeePayroll>(url, params)
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
          //  console.log('calculationPayroll', response);
        }),
          catchError(e=>{  
              this.spinnerService.hideAll();
              let newEntity : EmployeePayroll
              this.notificationService.smallBoxError(e.error.messages[0]); 
                return Observable.throw(newEntity);
            })
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/mpayroll-concept.service.ts